import { useTranslation } from 'react-i18next';

export const whatsAppUrl = (message = undefined) => {
    const { t } = useTranslation();
    const text = message ? message : t('i18nCommons.footer.whatsapp_message');
    const number = t('i18nCommons.footer.whatsapp').replaceAll(/\D/g, '');
    return `https://api.whatsapp.com/send/?phone=${number}&text=${encodeURIComponent(text)}&type=phone_number&app_absent=0`;
};
